var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-toolbar',{staticClass:"sub-menu",attrs:{"fixed":""}},[_vm._l((_vm.items),function(item){return [_c('span',{key:item.name,class:{ active : _vm.isActive(item), link: true }},[_c('router-link',{attrs:{"to":{ name: item.name },"name":`LoyaltySubmenuLink${item.name}`}},[_vm._v(_vm._s(item.label))])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }